import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { Lock } from "@/api/locks";
import { CodependentHandbookProps } from "../modals/modalBuilder";
import { useMemo } from "react";

export function CodependentLockHandbook(
  props: CodependentHandbookProps & AutocompleteProps<Lock>,
) {
  const locks = useAppSelector((state) => state.handbooks.lock);

  const items = useMemo(() => {
    const [location] = props.deps;
    return locks.filter((lock) => lock.location?.id === Number(location));
  }, [locks, props.deps]);

  return (
    <Autocomplete
      defaultItems={items}
      label="Замок"
      placeholder="Выберите замок"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function NewLockHandbook(props: AutocompleteProps<Lock>) {
  const items = useAppSelector((state) => state.handbooks.lock);

  return (
    <Autocomplete
      defaultItems={items}
      label="Замок"
      placeholder="Выберите замок"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function LockHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
}) {
  const items = useAppSelector((state) => state.handbooks.lock);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Замок"
      placeholder="Выберите замок"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}
    >
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
        >{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
